import {Component, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material';

/**------------------------------------------------------
 * Component for Shipment Info Modal Window
 *------------------------------------------------------*/

@Component({
  selector: 'shipment-dialog',
  template: `
        <div class='modal-content'>
            <div class='modal-title bg-primary'>
                <h3 style='margin-top: 0;'>Shipment details</h3>
            </div>
            <div class='modal-body'>
                <table class='dtls-table details-table' border='0' cellpadding='7' cellspacing='0'>
                    <thead>
                        <tr>
                            <th class='text-primary' style='text-align: left;'>Shipment from</th>
                            <th class='text-primary' style='text-align: left;'>Shipment to</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <span class='title'>Pickup country: </span>
                                <span class='value'>{{details.consignor.country}}</span>
                            </td>
                            <td>
                                <span class='title'>Delivery country: </span>
                                <span class='value'>{{details.consignee.country}}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span class='title'>Pickup city: </span>
                                <span class='value'>{{details.consignor.city}}</span>
                            </td>
                            <td>
                                <span class='title'>Delivery city: </span>
                                <span class='value'>{{details.consignee.city}}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span class='title'>Pickup address: </span>
                                <span class='value'>{{details.consignor.address}}</span>
                            </td>
                            <td>
                                <span class='title'>Delivery address: </span>
                                <span class='value'>{{details.consignee.address}}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span class='title'>Pickup zip: </span>
                                <span class='value'>{{details.consignor.zip}}</span>
                            </td>
                            <td>
                                <span class='title'>Delivery zip: </span>
                                <span class='value'>{{details.consignee.zip}}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span class='title'>Pickup name: </span>
                                <span class='value'>{{details.consignor.name}}</span>
                            </td>
                            <td>
                                <span class='title'>Delivery name: </span>
                                <span class='value'>{{details.consignee.name}}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span class='title'>Pickup email: </span>
                                <span class='value'>{{details.consignor.email}}</span>
                            </td>
                            <td>
                                <span class='title'>Delivery email: </span>
                                <span class='value'>{{details.consignee.email}}</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span class='title'>Pickup phone: </span>
                                <span class='value'>{{details.consignor.phone}}</span>
                            </td>
                            <td>
                                <span class='title'>Delivery phone: </span>
                                <span class='value'>{{details.consignee.phone}}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <div class='section' style='margin-top: 15px;'>
                    <div class='section-content details-list' style='display: flex; flex-wrap: wrap; align-items: stretch;'>
                        <div class='collection-item' style='flex-grow: 1; padding: 5px;'>
                            <span class='details-list__title'>Price</span>
                            <p>{{details.amount}}</p>
                        </div>
                        <div class='collection-item' style='flex-grow: 1; padding: 5px;'>
                            <span class='details-list__title'>Vat</span>
                            <p>{{details.vat}}</p>
                        </div>
                        <div class='collection-item' style='flex-grow: 1; padding: 5px;'>
                            <span class='details-list__title'>Currency</span>
                            <p>{{details.currency}}</p>
                        </div>
                        <div class='collection-item' style='flex-grow: 1; padding: 5px;'>
                            <span class='details-list__title'>Document</span>
                            <p>
                                <a *ngIf='details.pdfs.doc'
                                   (click)='openWindow(details.pdfs.doc)' href='javascript:void(0);'>
                                    Doc
                                </a>
                                <span *ngIf='!details.pdfs.doc'>None docs</span>
                            </p>
                        </div>
                    </div>
                </div>

                <div class='section' *ngIf='allExtraCharges.length > 0'>
                    <div class='section-title text-primary'>Extra Chages</div>
                    <div style='max-width: 100%; overflow-x: auto;'>
                        <table style='width: 100%; min-width: 400px; text-align: right'>
                            <thead>
                                <tr>
                                    <td style='text-align: left;'><b>Date:</b></td>
                                    <td style='text-align: left;'><b>Description:</b></td>
                                    <td><b>Amount:</b></td>
                                    <td><b>VAT(%):</b></td>
                                    <td><b>VAT:</b></td>
                                    <td><b>Total:</b></td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor='let item of allExtraCharges;' [class.text-warn]='item.status == 0'>
                                    <td style='text-align: left;'>{{item.date | date: 'dd.MM.yy'}}</td>
                                    <td style='text-align: left;'>{{item.description}}</td>
                                    <td>{{item.amount}}</td>
                                    <td>{{item.vatPercent}}</td>
                                    <td>{{item.vat | number : '1.2-2'}}</td>
                                    <td>{{item.total | number : '1.2-2'}}</td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td>
                                        <b style='padding-top: 5px; margin-top: 5px; border-top: 1px solid #999; display: block;'>
                                            {{details.extra_charge | number : '1.2-2'}}
                                        </b>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <mat-dialog-actions align='end' style='margin-bottom: 0;'>
                <button mat-raised-button color='primary' class='right' style='color: #fff;' (click)='closeModal()'>Close</button>
            </mat-dialog-actions>
        </div>
    `
})
export class ShipmentDialogComponent implements OnInit {
  details: any;
  allExtraCharges = [];


  constructor(public dialogRef: MatDialogRef<ShipmentDialogComponent>) { }

  ngOnInit() {
    if (this.details.extra_charge_payments.length > 0) {
      const extraPayments = this.details.extra_charge_payments;
      for (const i in extraPayments) {
        const extraCharges = extraPayments[i].extra_charges;
        const status = extraPayments[i].status;
        for (const j in extraCharges) {
          this.allExtraCharges.push({
            status: status,
            date: extraCharges[j].created_at,
            description: extraCharges[j].description,
            amount: extraCharges[j].amount,
            vatPercent: extraCharges[j].vat_percent,
            vat: extraCharges[j].vat,
            total: extraCharges[j].total
          });
        }
      }
    }
  }
  openWindow(href) {
    window.open(href, '');
    return false;
  }
  closeModal() {
    this.dialogRef.close('Yes!');
  }
}



// WEBPACK FOOTER //
// ./src/app/components/atoms/shipment-dialog/shipment-dialog.component.ts